export var headers = {
	"Project-Id-Version": "ox.en_US",
	"Report-Msgid-Bugs-To": "",
	"POT-Creation-Date": "",
	"PO-Revision-Date": "2015-02-25 11:03+0100",
	"Last-Translator": "",
	Language: "en_US",
	"Language-Team": "American English <kde-i18n-de@kde.org>",
	"Content-Type": "text/plain; charset=UTF-8",
	"Content-Transfer-Encoding": "8bit",
	"Plural-Forms": "nplurals=2; plural=(n != 1);",
	"MIME-Version": "1.0",
	"X-Generator": "Poedit 1.6.10",
	"X-POOTLE-MTIME": "1410268670.000000"
};
export default {
	headers: headers
};
